import { useAccountStore } from '@/stores/account';
import type { SegmentationContext } from '../types/featureFlag.types';

function normalizeId(id: string | number | undefined | null): string | undefined {
  if (id === undefined || id === null) return undefined;
  const value = String(id);
  return value.length > 0 ? value : undefined;
}

function normalizeString(value: string | undefined | null): string | undefined {
  if (!value) return undefined;
  return value;
}

/**
 * Lee el contexto del usuario actual desde el account store. Se invoca dentro
 * del computed de `getFeatureFlag` para mantener la API pública sin parámetros
 * adicionales.
 *
 * `isReady` se apoya en el getter `isKycReady` del account store: mientras sea
 * `false`, las flags con `segmentation` se resuelven a `enabled: false`. Cuando
 * el endpoint de KYC responde, la asignación a `kycStatus` dispara la
 * reactividad y las flags se reevalúan automáticamente.
 */
export function readSegmentationContext(): SegmentationContext {
  const accountStore = useAccountStore();
  const kyc = accountStore.kycStatus;
  const wallet = accountStore.getBalanceWalletMain;

  return {
    isReady: accountStore.isKycReady,
    company_id: normalizeId(kyc?.company?.id),
    user_id: normalizeId(kyc?.b2bUser?.id),
    country: normalizeString(kyc?.company?.addressCountry?.country),
    email: normalizeString(kyc?.b2bUser?.email),
    currency: normalizeString(wallet?.currency),
  };
}
